import Helmet from 'react-helmet';
import { styled } from '@mui/material/styles';

import {
  GlobalStyles,
  Grid,
} from '@mui/material';
import '../../App.css';

import PublicLayout from './PublicLayout';
import PropTypes from 'prop-types';
import { ContentWrap, GridCenterAligned as GridCenterAlignedBase, GridContentItem } from '../common/GridLayout';
import { Headline as BaseHeadline } from '../common/PublicTypography';

const shadeBgStyles = () => ({
  body: {
    color: '#B4C9FF',
  },
  '#root > div': {
    minHeight: '100vh'
  }
});

const GridMobileWithBackground = styled(Grid)`
  position: relative;

  &:before {
    ${props => props.theme.breakpoints.down('md')} {
      content: '';
      background-image: url('/bg-home.png');
      height: 100%;
      position: absolute;
      top: 0;
      width: calc(100vw + 30px);
      left: -30px;
      transform: scaleY(-1);
      background-size: 100% 88%;
      background-repeat: no-repeat;
    }
  }
`;

const Headline = styled(BaseHeadline)`
  font-size: 38px;
  line-height: 1.14;
  max-width: 280px;
  margin-top: 0;

  ${props => props.theme.breakpoints.up('md')} {
    font-size: 64px;
    max-width: none;
  }
`;

const GridCenterAligned = styled(GridCenterAlignedBase)`
  ${props => props.theme.breakpoints.up('md')} {
    gap: 70px;
  }
`;

function PageNotFound({ className }) {
  const pageBackgroundStyles = {
    body: {
      backgroundColor: '#274bde',
      backgroundImage: 'url("/v2/pixels-bg.svg")',
      backgroundPosition: 'top left',
      backgroundRepeat: 'repeat-x',
    },
  };

  return (
    <PublicLayout className={className}>
      <GlobalStyles styles={{ ...shadeBgStyles, ...pageBackgroundStyles }} />
      <Helmet title="Pixels - Page not found">
        <meta
          name="description"
          content="Welcome to Pixels! Oops.. Not found"
        />
      </Helmet>
      <GridCenterAligned container>
        <GridContentItem item xs={12} md={6}>
          <ContentWrap className={'ctn-root'} id="ContentWrap">
            <Headline variant={'h1'}>Page not found</Headline>
            <p>Oops! The page you're looking for doesn't exist.</p>

          </ContentWrap>
        </GridContentItem>
        <Grid
          item
          xs={12}
          md={6}
          sx={theme => ({
            display: 'flex',
            flexDirection: 'column',
            [theme.breakpoints.down('md')]: {
              display: 'none',
            },
          })}
          id="LoginShowcaseImageWrapper"
        >
        </Grid>
      </GridCenterAligned>
      <GridMobileWithBackground
        sx={theme => ({
          [theme.breakpoints.up('md')]: {
            display: 'none',
          },
        })}
      >
      </GridMobileWithBackground>
    </PublicLayout>
  );
}

PageNotFound.propTypes = {
  className: PropTypes.string,
};

export default styled(PageNotFound)`
  .content-root {
    display: flex;
  }

  .content-inner {
    max-width: none;
    padding: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    > div:first-of-type {
      flex: 1;
    }
  }

  ${props => props.theme.breakpoints.up('md')} {
    .ctn-root {
      padding-top: 20px;
    }
  }
`;
